import { createSlice } from "@reduxjs/toolkit";
import API from "../../API/urlConstants";

const token = localStorage.getItem(API.AUTH_TOKEN);

const initialState = {
    loggedIn: !!token,
    otpVerified: false,

};

const authSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        login(state, action) {
            state.loggedIn = true;
            state.otpVerified = false; // Reset OTP status on new login
        },

        logout(state) {
            state.loggedIn = false;

            return state;
        },
        verifyOtp(state) {
            state.otpVerified = true;
          },
    },
});

export const authActions = authSlice.actions;
export default authSlice.reducer;